import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { AuthProvider } from './contexts/AuthContext';
import MobileNavBar from './components/feature/MobileNavBar';
import { useEffect } from 'react';
import { fetchExchangeRates } from './services/duffelApi';

function App() {
  useEffect(() => {
    // Inicializar taxas de câmbio e configurações globais
    fetchExchangeRates().catch(err => console.error('Erro ao inicializar taxas:', err));
  }, []);

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <AppRoutes />
        <MobileNavBar />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
